import { service } from '@ember/service';
import Controller from '@ember/controller';

export default class RequestInformationReviewController extends Controller {
  @service currentPractice;

  get useBookAppointmentLanguage() {
    return Boolean(this.currentPractice.get('useBookAppointmentLanguage'));
  }
}
